module.exports = new __parcel__URL__("all_tab_active.dcc7a94d.png").toString();